<template>
  <div id="app">
    <navbar />
    <banner />
    <solutions id="solutions"/>
    <hr>
    <partners id="partners"/>
    <hr>
    
    <contacts id="contacts"/>
  </div>
</template>

<script>
  import Banner from "@/components/Banner";
  import Navbar from "@/components/Navbar";
  import Contacts from "@/components/Contacts";
  import Solutions from "@/components/Solutions";
  import Partners from "@/components/Partners";
  export default {
    name: "App",
    components: {
      Banner,
      Navbar,
      Contacts,
      Solutions,
      Partners,
    }
  };
</script>
